import DeletePaymentMethodModal from "./DeletePaymentMethodModal";

export default DeletePaymentMethodModal;
